import { keyframes } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import { css } from 'twin.macro';

const animateBlink = keyframes`
	to {
		opacity: 0;
	}
`;

const cssCaret = ({ blinkDuration }) => css`
  position: relative;

  ::before, ::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
	
	::after {
		width: 0.4em;
		height: 100%;
		background: var(--color-light);
		animation: ${animateBlink} ${blinkDuration}ms infinite;
	}
`;


export default function TextCodeFor({ showPoint, showCaretDuringDelay, delay, charWriteSpeed, blinkDuration, delayCaretHide, children, onNext, onAnimationEnd, ...props }) {
	const [renderedChildren, setRenderedChildren] = useState('');
	const [showCaretDurDelay, setShowCaretDurDelay] = useState(showCaretDuringDelay);
	const [showCaret, setShowCaret] = useState(true);

	useEffect(() => {
		const startTime = new Date().getTime();
		let timerRender, timerCaret, i = 0;

		function renderWithDelay() {
			timerRender = setTimeout(() => {
				setRenderedChildren(prev => prev + children[i]);
				i++;

				if (i < children.length) {
					renderWithDelay();
				} else {
					timerCaret = setTimeout(() => {
						setShowCaret(false);
						onNext(new Date().getTime() - startTime);
						onAnimationEnd && onAnimationEnd(new Date().getTime() - startTime);
					}, delayCaretHide);
				}
			}, charWriteSpeed);
		}

		const timerDelay = setTimeout(() => {
			setShowCaretDurDelay(true);
			renderWithDelay();
		}, delay);

		return () => {
			clearTimeout(timerDelay);
			clearTimeout(timerRender);
			clearTimeout(timerCaret);
		};
	}, []);

	if(renderedChildren === 'undefined' || renderedChildren === 'false') {
		return null;
	}

	return (
		<div {...props}>
			{showPoint && '• '}{renderedChildren}
			{showCaret && showCaretDurDelay && (
				<span css={[
					cssCaret({
						blinkDuration
					})
				]}
				>
					&nbsp;
				</span>
			)}
		</div>
	);
}

// support ms only
TextCodeFor.defaultProps = {
	blinkDuration: 400,
	charWriteSpeed: 10,
	delayCaretHide: 0,
	showCaretDuringDelay: false
};
